import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { constants } from "@common/_constants";
import { refetch } from "@common/_services";
import { Error } from "@common/components/Atoms/Error";
import { IconEmail } from "@common/components/Atoms/Icons";
import { FacebookLink, LinkedInLink, TwitterLink } from "@common/components/Atoms/Links";
import Modal from "@common/components/Molecules/Modal";

interface ShareJobProps {
    isOpen: boolean;
    closeModal: () => void;
    job: {
        job_id: number;
        job_name: string;
    };
}

interface ShareJobState {
    error: boolean;
    errorMessage: string;
    joblink: string;
    emailLink: string;
    facebookLink: string;
    linkedInLink: string;
    twitterLink: string;
    reward: string;
    copied: string;
}

export class ShareJob extends React.Component<ShareJobProps, ShareJobState> {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            errorMessage: "",
            joblink: "",
            emailLink: "",
            facebookLink: "",
            linkedInLink: "",
            twitterLink: "",
            reward: "",
            copied: "copy",
        };

        this.onAfterOpen = this.onAfterOpen.bind(this);
        this.onLinkCopy = this.onLinkCopy.bind(this);
    }

    onAfterOpen() {
        const url = `${constants.GlobalConfig.apiUrl}/pro/v2/jobs/${
            this.props.job.job_id
        }/sharelinks`;

        const settings = {
            headers: {
                "Content-Type": "application/json",
            },
            method: "GET",
        };

        refetch(url, settings)
            .then(resp => resp.json())
            .then(json => {
                this.setState({
                    joblink: json.result.url,
                    emailLink: json.result.email_url,
                    facebookLink: json.result.facebook_url,
                    linkedInLink: json.result.linked_in_url,
                    twitterLink: json.result.twitter_url,
                    reward: json.result.agent_reward,
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    error: true,
                    errorMessage: err.message,
                });
            });
    }

    onLinkCopy() {
        this.setState({ copied: "copied!" });
        setTimeout(() => {
            this.setState({ copied: "copy" });
        }, 3000);
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                closeModal={this.props.closeModal}
                onAfterOpen={this.onAfterOpen}
                title="share job">
                <div className="c-block">
                    <Error show={this.state.error} description={this.state.errorMessage} />
                </div>
                <div className="c-block">
                    <h2 className="c-block__title">{this.props.job.job_name}</h2>
                </div>

                <div className="c-block c-block--copy">
                    <div className="c-block__body">
                        <input
                            type="text"
                            name="joblink"
                            readOnly={true}
                            value={this.state.joblink}
                            size={50}
                        />
                        <CopyToClipboard text={this.state.joblink} onCopy={this.onLinkCopy}>
                            <button className="c-button c-button--green">
                                {this.state.copied}
                            </button>
                        </CopyToClipboard>
                    </div>
                </div>

                <div className="c-block">
                    <p>
                        This is your custom job sharing link. If someone applies from your link and
                        is hired, <strong>you'll earn {this.state.reward}</strong>. Copy and paste
                        it wherever you want, or press a button below to easily share it with your
                        network.
                    </p>
                </div>

                <div className="c-block c-block--share">
                    <div className="c-button c-button--email">
                        <IconEmail /> <a href={this.state.emailLink}>email</a>
                    </div>
                    <FacebookLink url={this.state.facebookLink} />
                    <LinkedInLink url={this.state.linkedInLink} />
                    <TwitterLink url={this.state.twitterLink} />
                </div>
            </Modal>
        );
    }
}
